(() => {
  function initialize() {
    document.querySelectorAll('[data-pnm-product]').forEach(root => {
      if (root.dataset.pnmReady) return;
      root.dataset.pnmReady = 'true';
      const page = root.closest('.pnm-product-page');
      const dataNode = root.querySelector('[data-pnm-product-data]');
      if (!page || !dataNode) return;
      let data;
      try { data = JSON.parse(dataNode.textContent); } catch (_) { return; }
      const normalize = value => String(value || '').trim().toUpperCase().replace(/\s+/g, ' ');
      const lines = value => Array.isArray(value) ? value.map(x => String(x).trim()) : String(value || '').replace(/\r/g, '').trim().split('\n').map(x => x.trim());
      const brands = lines(data.brands), models = lines(data.models), years = lines(data.years);
      const aligned = brands.length === models.length && models.length === years.length;
      const records = aligned ? models.map((model, i) => ({brand: brands[i], model, year: years[i]})).filter(row => row.brand && row.model && /^\d{4}$/.test(row.year)) : [];
      const universalValues = ['UNIVERSAL', 'CUSTOM / UNIVERSAL', 'UNIVERSAL/CUSTOM', 'CUSTOM/UNIVERSAL'];
      const universal = (data.tags || []).some(tag => universalValues.includes(normalize(tag))) || models.some(model => universalValues.includes(normalize(model)));
      const card = root.querySelector('[data-pnm-fitment-card]');
      const details = root.querySelector('[data-pnm-details]');
      const tabButtons = Array.from(details.querySelectorAll('[data-pnm-tab]'));
      function showPanel(name, focus = false) {
        if (!tabButtons.some(button => button.dataset.pnmTab === name)) return;
        tabButtons.forEach(button => { const selected = button.dataset.pnmTab === name; button.setAttribute('aria-selected', String(selected)); button.tabIndex = selected ? 0 : -1; });
        details.querySelectorAll('[data-pnm-panel]').forEach(panel => { panel.hidden = panel.dataset.pnmPanel !== name; panel.setAttribute('role', 'tabpanel'); panel.setAttribute('aria-labelledby', 'pnm-tab-' + panel.dataset.pnmPanel); });
        if (focus) { const panel = details.querySelector('[data-pnm-panel="' + name + '"]'); panel.focus({preventScroll:true}); panel.scrollIntoView({behavior:matchMedia('(prefers-reduced-motion: reduce)').matches?'auto':'smooth',block:'start'}); }
      }
      details.dataset.ready = 'true';
      details.querySelector('[role=tablist]').hidden = false;
      tabButtons.forEach((button, i) => {
        button.addEventListener('click', () => { if(button.dataset.pnmTab === 'fitment') viewSelectedFitment(); else showPanel(button.dataset.pnmTab); });
        button.addEventListener('keydown', event => {
          let next;
          if (event.key === 'ArrowRight') next = (i + 1) % tabButtons.length;
          if (event.key === 'ArrowLeft') next = (i + tabButtons.length - 1) % tabButtons.length;
          if (event.key === 'Home') next = 0;
          if (event.key === 'End') next = tabButtons.length - 1;
          if (next !== undefined) { event.preventDefault(); showPanel(tabButtons[next].dataset.pnmTab); tabButtons[next].focus(); }
        });
      });
      showPanel(location.hash === '#pnm-fitment' ? 'fitment' : 'description');
      root.querySelector('[data-pnm-fitment-link]').addEventListener('click', event => { event.preventDefault(); viewSelectedFitment(); });
      details.querySelectorAll('[data-pnm-description-link]').forEach(link => link.addEventListener('click', event => { event.preventDefault(); showPanel('description', true); }));
      const checkBike = root.querySelector('[data-pnm-check-bike]');
      checkBike.setAttribute('aria-haspopup', 'dialog');
      checkBike.setAttribute('aria-controls', 'pnm-model-dialog');
      checkBike.setAttribute('aria-expanded', 'false');
      checkBike.addEventListener('click', () => {
        if (!window.PNMBikeSelector?.check) { showPanel('fitment', true); return; }
        window.PNMBikeSelector.check(checkBike, () => {
          updateFitment();
          card.tabIndex = -1;
          card.focus({preventScroll:true});
          card.scrollIntoView({behavior:matchMedia('(prefers-reduced-motion: reduce)').matches?'auto':'smooth',block:'center'});
        });
      });
      const grouped = new Map();
      records.forEach(row => { const key = normalize(row.brand) + '|' + normalize(row.model); if (!grouped.has(key)) grouped.set(key, {brand:row.brand,model:row.model,years:new Set()}); grouped.get(key).years.add(row.year); });
      function compactYears(values) {
        const list = Array.from(values).map(Number).sort((a,b) => a-b), parts=[];
        for (let i=0;i<list.length;i++) { const start=list[i]; let end=start; while (list[i+1]===end+1) end=list[++i]; parts.push(start===end?String(start):start+'–'+end); }
        return parts.join(', ');
      }
      const body = root.querySelector('[data-pnm-fitment-rows]');
      const brandOrder=['HONDA','YAMAHA','KAWASAKI','SUZUKI'];
      const sorted=Array.from(grouped.values()).sort((a,b) => {
        const ai=brandOrder.indexOf(normalize(a.brand)),bi=brandOrder.indexOf(normalize(b.brand));
        if(ai!==bi)return (ai<0?99:ai)-(bi<0?99:bi);
        return a.model.localeCompare(b.model,undefined,{numeric:true});
      });
      const fitmentRows = new Map();
      sorted.forEach(row => { const tr=document.createElement('tr'); fitmentRows.set(tr,row); [row.brand,row.model,compactYears(row.years)].forEach(value => { const td=document.createElement('td'); td.textContent=value; tr.append(td); }); tr.dataset.search=normalize(row.brand+' '+row.model+' '+Array.from(row.years).join(' ')); body.append(tr); });
      const fitmentSearch = root.querySelector('[data-pnm-fitment-search]');
      fitmentSearch.hidden = sorted.length <= 4;
      root.querySelector('label[for="pnm-fitment-search"]').hidden = fitmentSearch.hidden;
      root.querySelector('[data-pnm-fitment-table]').hidden = !sorted.length || universal;
      fitmentSearch.addEventListener('input', event => { const term=normalize(event.target.value); let count=0; Array.from(body.rows).forEach(row => { row.hidden=!row.dataset.search.includes(term); if(!row.hidden)count++; }); root.querySelector('[data-pnm-fitment-empty]').hidden=count>0; });
  function manufacturer(value) {
    const values = String(value || '').split(',').map(item => item.trim().replace(/ - ATV$/, ''));
    return values[0] && values.every(item => item === values[0]) ? values[0] : '';
  }

      function selection() {
        const bike=window.PNMBikeSelector?.selection?.();
        return bike?{brand:manufacturer(bike.brand),model:bike.model||'',year:bike.year||''}:{brand:'',model:'',year:''};
      }
      let highlightedBikeKey = null;
      const fitmentBikeKey = bike => JSON.stringify([normalize(bike.brand),normalize(bike.model),String(bike.year)]);
      function clearFitmentHighlight() {
        highlightedBikeKey = null;
        fitmentRows.forEach((record,row) => { row.classList.remove('pnm-fitment-selected'); row.removeAttribute('aria-current'); row.removeAttribute('tabindex'); });
      }
      function viewSelectedFitment() {
        const bike=selection();
        clearFitmentHighlight();
        fitmentSearch.value='';
        fitmentSearch.dispatchEvent(new Event('input',{bubbles:true}));
        const match=!universal && bike.brand && bike.model && Array.from(fitmentRows).find(([row,record]) => normalize(manufacturer(record.brand))===normalize(bike.brand) && normalize(record.model)===normalize(bike.model) && (!bike.year || record.years.has(String(bike.year))));
        if(!match){showPanel('fitment',true);return;}
        showPanel('fitment');
        const row=match[0];
        highlightedBikeKey=fitmentBikeKey(bike);
        row.classList.add('pnm-fitment-selected');
        row.setAttribute('aria-current','true');
        row.tabIndex=-1;
        requestAnimationFrame(() => {
          row.focus({preventScroll:true});
          row.scrollIntoView({behavior:matchMedia('(prefers-reduced-motion: reduce)').matches?'auto':'smooth',block:'center',inline:'nearest'});
        });
      }
      function updateFitment() {
        const bike=selection(), s=data.strings;
        if(highlightedBikeKey && highlightedBikeKey!==fitmentBikeKey(bike)) clearFitmentHighlight();
        let title=s.fitment_title, note=s.fitment_note, state='neutral', icon='?';
        if(universal){title=s.universal;note=s.universal_note;state='universal';icon='!';}
        else if(bike.model && bike.year && bike.brand){
          const found=records.some(row=>normalize(manufacturer(row.brand))===normalize(bike.brand)&&normalize(row.model)===normalize(bike.model)&&row.year===bike.year);
          if(found){title=s.fits;note='';state='match';icon='✓';}
          else if(records.length){title=s.not_listed;note=s.not_listed_note;state='warning';icon='!';}
          else{title=s.unknown;note=s.unknown_note;}
        }else if(bike.model){title=s.choose_year;note=s.fitment_note;}
        card.dataset.state=state;
        card.querySelector('[data-pnm-fitment-title]').textContent=title;
        const noteElement=card.querySelector('[data-pnm-fitment-note]');
        noteElement.textContent=note;
        noteElement.hidden=!note;
        card.querySelector('.pnm-fitment-icon').textContent=icon;
        const label=card.querySelector('[data-pnm-selected-bike]');
        label.hidden=universal||!bike.model; label.textContent=[bike.year,bike.brand,bike.model].filter(Boolean).join(' ');
        const button=card.querySelector('[data-pnm-check-bike]');button.hidden=universal;button.textContent=bike.model?s.change_bike:s.select_bike;
        const universalNotice=details.querySelector('[data-pnm-universal-notice]');
        if(universalNotice) universalNotice.hidden=!universal;
        const fitmentHelp=details.querySelector('[data-pnm-fitment-help]');
        if(fitmentHelp) fitmentHelp.hidden=universal;
        const fitmentFootnote=details.querySelector('.pnm-fitment-footnote');
        if(fitmentFootnote) fitmentFootnote.hidden=universal;
      }
      updateFitment();
      if(location.hash === '#pnm-fitment') requestAnimationFrame(viewSelectedFitment);
      window.addEventListener('hashchange',()=>{if(location.hash === '#pnm-fitment') viewSelectedFitment();});
      window.addEventListener('pnm:bike-change',updateFitment);
      window.addEventListener('storage',updateFitment);
      window.addEventListener('popstate',updateFitment);
      const rating=root.querySelector('[data-pnm-rating]');
      if(rating){const updateRating=()=>{const badge=rating.querySelector('[data-number-of-reviews]');rating.hidden=!(badge&&Number(badge.getAttribute('data-number-of-reviews'))>0);};updateRating();new MutationObserver(updateRating).observe(rating,{childList:true,subtree:true,attributes:true,attributeFilter:['data-number-of-reviews']});}
      const form=root.querySelector('form[data-product-form]'), add=form?.querySelector('[data-add-to-cart]'), quantity=form?.querySelector('[name=quantity]');
      const availability=root.querySelector('[data-pnm-availability]'), sticky=page.querySelector('[data-pnm-sticky]');
      if(!form||!add)return;
      const price=root.querySelector('.product_shop .product-price');
      const setText=(node,text)=>{if(node && node.textContent!==text)node.textContent=text;};
      function sync() {
        const id=form.querySelector('[name=id]')?.value;
        const variant=data.variants.find(item=>String(item.id)===String(id));
        if(variant){
          let state='stock',text=availability.dataset.stock,note='';
          if(!variant.available){state='sold';text=availability.dataset.soldOut;note='';}
          else if(!variant.tracked){state='available';text=availability.dataset.available;note='';}
          else if(variant.quantity<=0){state='order';text=availability.dataset.preorder;note=availability.dataset.preorderNote;}
          if(availability.dataset.state!==state)availability.dataset.state=state;setText(availability.querySelector('[data-pnm-stock]'),text);setText(availability.querySelector('[data-pnm-dispatch]'),note);
          if(!variant.available&&!add.disabled)add.disabled=true;
        }
        if(sticky){
          const stickyButton=sticky.querySelector('[data-pnm-sticky-submit]');if(stickyButton.disabled!==add.disabled)stickyButton.disabled=add.disabled;
          setText(stickyButton,add.querySelector('[data-add-to-cart-text]')?.textContent.trim()||add.textContent.trim());
          setText(sticky.querySelector('[data-pnm-sticky-quantity]'),quantity?.value||'1');
          if(price){const candidates=Array.from(price.querySelectorAll('.price-item'));const visible=candidates.filter(node=>node.getClientRects().length&&node.textContent.trim());const current=visible.find(node=>node.classList.contains('price-item--sale'))||visible[0];if(current)setText(sticky.querySelector('[data-pnm-sticky-price]'),current.textContent.trim());}
        }
      }
      let queued=false;
      const schedule=()=>{if(queued)return;queued=true;requestAnimationFrame(()=>{queued=false;sync();});};
      form.addEventListener('change',schedule);form.addEventListener('input',schedule);form.addEventListener('click',schedule);
      new MutationObserver(schedule).observe(add,{childList:true,subtree:true,attributes:true,attributeFilter:['disabled','class']});
      if(price)new MutationObserver(schedule).observe(price,{childList:true,subtree:true,characterData:true,attributes:true,attributeFilter:['class']});
      form.addEventListener('submit',event=>{if(quantity&&(!/^\d+$/.test(quantity.value)||Number(quantity.value)<1)){event.preventDefault();event.stopImmediatePropagation();quantity.value='1';quantity.focus();}},true);
      if(sticky){
        sticky.querySelector('[data-pnm-sticky-submit]').addEventListener('click',()=>{sync();if(!add.disabled)add.click();});
        new IntersectionObserver(entries=>{const entry=entries[0];const visible=!entry.isIntersecting&&entry.boundingClientRect.bottom<0;sticky.hidden=!visible;document.body.classList.toggle('pnm-sticky-visible',visible);},{threshold:0}).observe(add);
      }
      sync();
    });
  }
  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',initialize);else initialize();
  document.addEventListener('shopify:section:load',initialize);
})();
